import React, { useEffect, useState } from "react";
import { getCms } from "../api/services/cmsServices";

const PrivacyPolicy = () => {

    const [privacyPolicy, setPrivacyPolicy] = useState({});

    useEffect(() => {
        getPrivacyPolicy();
    }, []);

    const getPrivacyPolicy = async () => {
        const response = await getCms("privacy");
        if (response.status === 200) {
            setPrivacyPolicy(response.data?.data);
        }
    }

    return <div className="py-20 overflow-hidden">
        <div className="flex justify-center items-center bg-[#08206B] h-[180px] w-full border-b-[12px] border-[#56B22F]">
            <h1 className="text-white text-2xl md:text-4xl font-bold">Privacy Policy</h1>
        </div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center py-8 md:py-12">
                <h1 className="text-black text-2xl md:text-4xl font-bold mb-4 md:mb-8">{privacyPolicy?.title}</h1>

                <div dangerouslySetInnerHTML={{ __html: privacyPolicy?.description }} />
            </div>
        </div>
    </div>;
};

export default PrivacyPolicy;
